import {
  Button,
  Collapse,
  Grid,
  MenuItem,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { Icon } from "leaflet";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, Marker, Polyline, TileLayer, useMap, useMapEvents } from "react-leaflet";
import { ThemeProvider } from "styled-components";
import { getAlertTypeNames, getMuiTheme } from "../../../../utils/utils";
import palette, { polylineColors } from "../../../../../config/colorPalette";
import { clone, isEmpty, isNil } from "ramda";
import { ErrorText } from "./styled";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { IS_ONLINE, MAP_TYPES } from "../../../../../config/configmap";
import { styled } from "@mui/material/styles";
import ChannelInfo from "./components/channelInfo";
import MeasurementInfo from "./components/measurementInfo";
import { offsetPolygonPerSegment } from "./utils";

const EquipmentInfo = ({
  equipment,
  setEquipment,
  equipmentCollection,
  polylineDisplay,
  centroid,
  assetName,
  measures,
  setMeasures,
  measuresComputed,
  pIndexes,
  measuresAlerts,
  setMeasuresAlerts,
  thresholdsValues,
  setThresholdsValues,
  thresholdsRanges,
  setThresholdsRanges,
  objectMeasures,
  zones,
  setZones,
  infoToggle,
  setInfoToggle,
  channelAsignToggle,
  setChannelAsignToggle,
  channelNameAsignToggle,
  setChannelNameAsignToggle,
  susbtructureAsignToggle,
  setSusbtructureAsignToggle,
  susbtructureDataToggle,
  setSusbtructureDataToggle,
  channelDataToggle,
  setChannelDataToggle,
  channelPK,
  setChannelPK,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  measureToggle,
  setMeasureToggle,
  channelToggle,
  setChannelToggle,
  zoneToggle,
  setZoneToggle,
  errors,
  setErrors,
  subs,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [open, setOpen] = useState([]);
  const [inclinometers, setInclinometers] = useState([]);
  const [criticalPolygon, setCriticalPolygon] = useState([]);
  const [protectionPolygon, setProtectionPolygon] = useState([]);
  const thresholdType = useState(getAlertTypeNames(intl));
  const initializedRef = useRef(false);

  const handleToggle = (index) => {
    let newOpen = clone(open);
    newOpen[index] = !newOpen[index];
    for (let j = 0; j < newOpen.length; j++) {
      if (newOpen[index] && index !== j) {
        newOpen[j] = false;
      }
    }
    setOpen(newOpen);
  };

  const useStyles = {
    colorSample: {
      width: "20px",
      height: "20px",
      display: "inline-block",
      marginRight: "8px",
      border: "1px solid #ccc",
      borderRadius: "50%",
    },
  };
  const BootstrapButton = styled(Button)({
    marginBottom: "5%",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: palette.primary,
    borderColor: palette.secondary,
    "&:hover": {
      backgroundColor: palette.link,
      borderColor: palette.secondary,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: palette.link,
      borderColor: palette.secondary,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(134,26,33,.5)",
    },
  });

  const customCentroidIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-marker-icon.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });
  const customInclinometerIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-marker-icon-inclinometer.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });
  const customIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-equipment-marker-icon.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });

  const customShadowIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-equipment-marker-icon.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
    shadowUrl: require("../../../../../images/yellow-shadow.png"), // Ajusta la ruta de la sombra según tu estructura de archivos
    shadowSize: [150, 100], // Tamaño de la sombra, ajusta según sea necesario
    shadowAnchor: [74, 75], // Anclaje de la sombra, ajusta según sea necesario
  });

  const [mapType] = useState("regular");

  const AddEquipment = () => {
    // eslint-disable-next-line no-unused-vars
    const map = useMapEvents({
      click: (e) => {
        if (equipment.length < equipmentCollection.length && equipmentCollection[0] !== "") {
          setInfoToggle((prev) => [...prev, true]);
          setChannelAsignToggle((prev) => [...prev, false]);
          setChannelNameAsignToggle((prev) => [...prev, false]);
          setMeasureToggle((prev) => [...prev, false]);
          setChannelDataToggle((prev) => [...prev, [false]]);
          setSusbtructureAsignToggle((prev) => [...prev, [false]]);
          setSusbtructureDataToggle((prev) => [...prev, [false]]);
          if (!isEmpty(polylineDisplay)) {
            setChannelPK((prev) => [
              ...prev,
              [Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100],
            ]);
          } else {
            setChannelPK((prev) => [...prev, [0]]);
          }

          setEquipmentInterMeasurement((prev) => [...prev, 0]);
          let newChannelToggle = clone(channelToggle);
          let newZoneToggle = clone(zoneToggle);
          for (let indexEquipment = 0; indexEquipment < Object.keys(measures).length; indexEquipment++) {
            if (isNil(newZoneToggle[indexEquipment]) && isNil(newChannelToggle[indexEquipment])) {
              newChannelToggle.push([]);
              newZoneToggle.push([]);
              for (
                let indexMeasure = 0;
                indexMeasure < measures[`equipment${indexEquipment + 1}`].length;
                indexMeasure++
              ) {
                newChannelToggle[indexEquipment].push([]);
                newChannelToggle[indexEquipment][indexMeasure].push(false);
                newZoneToggle[indexEquipment].push([]);
                newZoneToggle[indexEquipment][indexMeasure].push([]);
                newZoneToggle[indexEquipment][indexMeasure][0].push(false);
              }
            }
          }
          let cloneRange = clone(thresholdsRanges);
          for (let indexEquipment = 0; indexEquipment < Object.keys(thresholdsRanges).length; indexEquipment++) {
            for (
              let indexChannel = 0;
              indexChannel < thresholdsRanges[`equipment${indexEquipment + 1}`].length;
              indexChannel++
            ) {
              for (
                let indexChannelZone = 0;
                indexChannelZone < thresholdsRanges[`equipment${indexEquipment + 1}`][indexChannel].length;
                indexChannelZone++
              ) {
                for (
                  let indexRange = 0;
                  indexRange <
                  thresholdsRanges[`equipment${indexEquipment + 1}`][indexChannel][indexChannelZone].length;
                  indexRange++
                ) {
                  if (!isEmpty(polylineDisplay)) {
                    cloneRange[`equipment${indexEquipment + 1}`][indexChannel][indexChannelZone][indexRange][1] =
                      Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100;
                  } else {
                    cloneRange[`equipment${indexEquipment + 1}`][indexChannel][indexChannelZone][indexRange][1] = 0;
                  }
                }
              }
            }
          }
          setThresholdsRanges(cloneRange);
          setChannelToggle(newChannelToggle);
          setZoneToggle(newZoneToggle);
          setEquipment((prevEquipment) => [
            ...prevEquipment,
            {
              equipmentID: ``,
              name: ``,
              model: "",
              manufacturer: ``,
              latitude: e.latlng.lat,
              longitude: e.latlng.lng,
              statusDetails: "OK",
              measureFrequency: 0,
              measurementState: false,
              asset: assetName,
              equipmentType: getRemainingEquipmentType(prevEquipment, equipmentCollection),
              ipAddress: "0.0.0.0",
              supportNotificationStatus: false,
              spatialResolution: getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS" ? 0 : null,
              criticalArea:
                getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS"
                  ? { distance: 0, polygon: null }
                  : null,
              protectionArea:
                getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS"
                  ? { distance: 0, polygon: null }
                  : null,
              channels: [0],
              channelsNames: [""],
              channelsLength: !isEmpty(polylineDisplay)
                ? [Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100]
                : [0],
              channelsMeasurementTime:
                getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS" ? null : [0],
              channelsSpatialResolution:
                getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS" ? null : [0],
              channelsAcquisitionFrequency:
                getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS" ? [0] : null,
              channelsGaugeLength: getRemainingEquipmentType(prevEquipment, equipmentCollection) === "DAS" ? [0] : null,
              channelsSamplingInterval: [0],
              channelsStates: [false],
              channelsInfo: [""],
              channelsSubStructures: subs
                ? !isEmpty(polylineDisplay)
                  ? [[{ name: "", type: "generic", section_count: 1, polyline: 1 }]]
                  : [[{ name: "", type: "inclinometer", section_count: 1, polyline: [0, 0] }]]
                : null,
            },
          ]);
        }
      },
    });
    return null;
  };

  const getRemainingEquipmentType = (equipment, equipmentCollection) => {
    const usedEquipmentTypes = equipment.map((item) => item.equipmentType);
    const remainingEquipmentType = equipmentCollection.find((type) => !usedEquipmentTypes.includes(type));
    return remainingEquipmentType || equipmentCollection[0];
  };

  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!initializedRef.current && !isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
      map.fitBounds(polyline[0].points);
      initializedRef.current = true;
    }
    return null;
  };

  useEffect(() => {
    const inclinometerList = [];
    if (subs) {
      for (let indexEquipment = 0; indexEquipment < equipment.length; indexEquipment++) {
        for (
          let channelIndex = 0;
          channelIndex < equipment[indexEquipment].channelsSubStructures.length;
          channelIndex++
        ) {
          for (
            let subIndex = 0;
            subIndex < equipment[indexEquipment].channelsSubStructures[channelIndex].length;
            subIndex++
          ) {
            if (equipment[indexEquipment].channelsSubStructures[channelIndex][subIndex].type === "inclinometer") {
              inclinometerList.push(equipment[indexEquipment].channelsSubStructures[channelIndex][subIndex].polyline);
            }
          }
        }
      }
    }

    setInclinometers(inclinometerList);
  }, [equipment, subs]);

  useEffect(() => {
    if (!isEmpty(polylineDisplay) && !isEmpty(equipment)) {
      for (let indexEquipment = 0; indexEquipment < equipment.length; indexEquipment++) {
        const newEquipments = [...equipment];
        const updatedEquipment = { ...newEquipments[indexEquipment] };
        let newChannelPk = clone(channelPK);
        for (let newIndex = 0; newIndex < updatedEquipment.channels.length; newIndex++) {
          if (newChannelPk[indexEquipment][newIndex] === 0) {
            newChannelPk[indexEquipment][newIndex] =
              Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100;
          }
        }
        if (updatedEquipment.channelsLength.length === 1 && isNil(updatedEquipment.channelsLength[0])) {
          if (!Array.isArray(updatedEquipment.channelsLength)) {
            updatedEquipment.channelsLength = [];
          }
          for (let newIndex = 0; newIndex < updatedEquipment.channels.length; newIndex++) {
            updatedEquipment.channelsLength.push(
              Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100,
            );
          }
        }

        let newThresholdValues = clone(thresholdsValues);
        let newThresholdRanges = clone(thresholdsRanges);
        for (let indMed = 0; indMed < newThresholdValues[`equipment${indexEquipment + 1}`].length; indMed++) {
          for (let newIndex = 0; newIndex < updatedEquipment.channels.length; newIndex++) {
            if (newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex][0] === 0) {
              newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex][0] = [
                0,
                Math.round(polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100) / 100,
              ];
            }
          }

          //updatedEquipment.channels = parseInt(e.target.value);
          newEquipments[indexEquipment] = updatedEquipment;
          setChannelPK(newChannelPk);
          setThresholdsRanges(newThresholdRanges);
          setEquipment(newEquipments);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [polylineDisplay]);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Grid Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid item style={{ flex: "1", marginRight: "1%" }}>
            {equipmentCollection[0] === "" && (
              <h3>{intl.formatMessage({ id: "first.polyline.and.equipment.to.equipment" })}</h3>
            )}
            <section
              style={{
                position: "relative",
                width: "100%",
                borderRadius: "4px",
                border: `1px solid ${palette.primary}`,
                margin: "1.5rem 0",
                padding: "1%",
              }}
            >
              <h1 style={{ marginBottom: "1%" }}>Equipments</h1>
              {equipment.length > 0 &&
                equipment.map((e, indexEquipment) => {
                  return (
                    <div>
                      <Button id={`equipmetnCollapse${indexEquipment}`} onClick={() => handleToggle(indexEquipment)}>
                        {e.equipmentID} - {e.equipmentType}
                      </Button>
                      <DeleteForeverIcon
                        onClick={() => {
                          const newEquipments = clone(equipment);
                          newEquipments.splice(indexEquipment, 1);
                          setEquipment(newEquipments);
                        }}
                        sx={{ color: palette.primary, cursor: "pointer" }}
                      />
                      <Collapse in={open[indexEquipment]}>
                        <div>
                          <h1
                            onClick={() => {
                              let newInfoToggle = clone(infoToggle);
                              if (newInfoToggle[indexEquipment]) {
                                newInfoToggle[indexEquipment] = false;
                              } else {
                                newInfoToggle[indexEquipment] = true;
                              }
                              setInfoToggle(newInfoToggle);
                            }}
                            style={{ marginBottom: "3%" }}
                          >
                            {intl.formatMessage({ id: "equipment.info" })}
                            {!infoToggle[indexEquipment] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                          </h1>
                          <Collapse in={infoToggle[indexEquipment]}>
                            <TextField
                              id={"equipment" + indexEquipment + "name"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.name}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.name = e.target.value;
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              error={errors[equipment + indexEquipment + "name"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "equipment.name" })}
                              required
                            ></TextField>
                            {!isNil(errors["equipment" + indexEquipment + "name"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors["equipment" + indexEquipment + "name"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={"equipment" + indexEquipment + "manufacturer"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.manufacturer}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.manufacturer = e.target.value;
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              error={errors[equipment + indexEquipment + "manufacturer"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "equipment.manufacturer" })}
                              required
                            ></TextField>
                            {!isNil(errors["equipment" + indexEquipment + "manufacturer"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors["equipment" + indexEquipment + "manufacturer"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={"equipment" + indexEquipment + "model"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.model}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.model = e.target.value;
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              error={errors[equipment + indexEquipment + "model"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "equipment.model" })}
                              required
                            ></TextField>
                            {!isNil(errors["equipment" + indexEquipment + "model"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors["equipment" + indexEquipment + "model"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={"equipment" + indexEquipment + "equipmentID"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.equipmentID}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.equipmentID = e.target.value;
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              error={errors[equipment + indexEquipment + "equipmentID"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "equipment.equipmentID" })}
                              required
                            ></TextField>
                            {!isNil(errors["equipment" + indexEquipment + "equipmentID"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors["equipment" + indexEquipment + "equipmentID"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={"equipment" + indexEquipment + "_IP"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.ipAddress}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                const regex =
                                  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                                const isValidInput = regex.test(e.target.value);
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else if (!isValidInput) {
                                  newErrors[e.target.id] = "must.ip";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.ipAddress = e.target.value;
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              error={errors[equipment + indexEquipment + "_IP"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "ip.address" })}
                              required
                            ></TextField>
                            {!isNil(errors["equipment" + indexEquipment + "_IP"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors["equipment" + indexEquipment + "_IP"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={"equipment" + indexEquipment + "_channels"}
                              style={{ margin: "0 0.2rem 0.8rem" }}
                              defaultValue={e.channels.length}
                              inputProps={{ min: 1 }}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };

                                const newLength = parseInt(e.target.value);
                                const actualLength = updatedEquipment.channels.length;
                                if ((newLength > actualLength) & subs) {
                                  for (let i = actualLength; i < newLength; i++) {
                                    if (!isEmpty(polylineDisplay)) {
                                      updatedEquipment.channelsSubStructures.push([
                                        {
                                          name: "",
                                          type: "generic",
                                          section_count: 1,
                                          polyline: 1,
                                        },
                                      ]);
                                    } else {
                                      updatedEquipment.channelsSubStructures.push([
                                        {
                                          name: "",
                                          type: "inclinometer",
                                          section_count: 1,
                                          polyline: [0, 0],
                                        },
                                      ]);
                                    }

                                    let newSubToggle = clone(susbtructureAsignToggle);
                                    newSubToggle[indexEquipment].push(false);
                                    setSusbtructureAsignToggle(newSubToggle);
                                  }
                                } else if ((newLength < actualLength) & subs) {
                                  updatedEquipment.channelsSubStructures.splice(newLength);
                                  let newSubToggle = clone(susbtructureAsignToggle);
                                  newSubToggle[indexEquipment] = newSubToggle[indexEquipment].slice(0, newLength);
                                  setSusbtructureAsignToggle(newSubToggle);
                                }
                                updatedEquipment.channels = [];
                                updatedEquipment.channelsNames = [];
                                updatedEquipment.channelsLength = [];
                                updatedEquipment.channelsSpatialResolution = e.equipmentType === "DAS" ? null : [];
                                updatedEquipment.channelsSamplingInterval = [];
                                updatedEquipment.channelsMeasurementTime = e.equipmentType === "DAS" ? null : [];
                                updatedEquipment.channelsAcquisitionFrequency = e.equipmentType === "DAS" ? [] : null;
                                updatedEquipment.channelsGaugeLength = e.equipmentType === "DAS" ? [] : null;
                                let newChannelDataToggle = clone(channelDataToggle);
                                newChannelDataToggle[indexEquipment] = [];
                                let newChannelPk = clone(channelPK);
                                for (let newIndex = 0; newIndex < parseInt(e.target.value); newIndex++) {
                                  newChannelDataToggle[indexEquipment].push(false);
                                  if (isNil(newChannelPk[indexEquipment][newIndex])) {
                                    if (!isEmpty(polylineDisplay)) {
                                      newChannelPk[indexEquipment].push(
                                        Math.round(
                                          polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100,
                                        ) / 100,
                                      );
                                    } else {
                                      newChannelPk[indexEquipment].push(0);
                                    }
                                  }
                                }
                                let newThresholdValues = clone(thresholdsValues);
                                let newThresholdRanges = clone(thresholdsRanges);
                                let newZones = clone(zones);
                                let newChannelToggle = clone(channelToggle);
                                let newZoneToggle = clone(zoneToggle);
                                for (let newIndex = 0; newIndex < parseInt(e.target.value); newIndex++) {
                                  updatedEquipment.channels.push(0);
                                  updatedEquipment.channelsNames.push("");
                                  if (!isEmpty(polylineDisplay)) {
                                    updatedEquipment.channelsLength.push(
                                      Math.round(
                                        polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100,
                                      ) / 100,
                                    );
                                  } else {
                                    updatedEquipment.channelsLength.push(0);
                                  }

                                  updatedEquipment.channelsSpatialResolution.push(0);
                                  updatedEquipment.channelsSamplingInterval.push(0);
                                  updatedEquipment.channelsMeasurementTime.push(0);
                                }
                                for (
                                  let indMed = 0;
                                  indMed < newThresholdValues[`equipment${indexEquipment + 1}`].length;
                                  indMed++
                                ) {
                                  if (newLength > actualLength) {
                                    if (isNil(newZones[indexEquipment][indMed])) {
                                      newZones[indexEquipment].push([]);
                                    }

                                    for (let newIndex = actualLength; newIndex < newLength; newIndex++) {
                                      if (
                                        isNil(newThresholdValues[`equipment${indexEquipment + 1}`][indMed][newIndex]) ||
                                        isNil(newThresholdValues[`equipment${indexEquipment + 1}`][indMed][newIndex][0])
                                      ) {
                                        newThresholdValues[`equipment${indexEquipment + 1}`][indMed].push([]);
                                        newThresholdValues[`equipment${indexEquipment + 1}`][indMed][newIndex].push([
                                          { type: null, value: 0 },
                                        ]);
                                      }
                                      if (
                                        isNil(newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex]) ||
                                        isNil(newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex][0])
                                      ) {
                                        newThresholdRanges[`equipment${indexEquipment + 1}`][indMed].push([]);
                                        if (!isEmpty(polylineDisplay)) {
                                          newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex].push([
                                            0,
                                            Math.round(
                                              polylineDisplay[0].points[polylineDisplay[0].points.length - 1].pk * 100,
                                            ) / 100,
                                          ]);
                                        } else {
                                          newThresholdRanges[`equipment${indexEquipment + 1}`][indMed][newIndex].push([
                                            0, 0,
                                          ]);
                                        }
                                      }
                                      if (isNil(newZones[indexEquipment][indMed][newIndex])) {
                                        newZones[indexEquipment][indMed].push(1);
                                      }
                                      if (isNil(newChannelToggle[indexEquipment][indMed][newIndex])) {
                                        newChannelToggle[indexEquipment][indMed].push(false);
                                      }
                                      if (isNil(newZoneToggle[indexEquipment][indMed][newIndex])) {
                                        newZoneToggle[indexEquipment][indMed].push([]);
                                        newZoneToggle[indexEquipment][indMed][newIndex].push(false);
                                      }
                                    }
                                  } else if (newLength < actualLength) {
                                    newThresholdValues[`equipment${indexEquipment + 1}`][indMed] = newThresholdValues[
                                      `equipment${indexEquipment + 1}`
                                    ][indMed].slice(0, newLength);
                                    newThresholdRanges[`equipment${indexEquipment + 1}`][indMed] = newThresholdRanges[
                                      `equipment${indexEquipment + 1}`
                                    ][indMed].slice(0, newLength);
                                    newZones[indexEquipment][indMed] = newZones[indexEquipment][indMed].slice(
                                      0,
                                      newLength,
                                    );
                                    newChannelToggle[indexEquipment][indMed] = newChannelToggle[indexEquipment][
                                      indMed
                                    ].slice(0, newLength);
                                    newZoneToggle[indexEquipment][indMed] = newZoneToggle[indexEquipment][indMed].slice(
                                      0,
                                      newLength,
                                    );
                                  }

                                  //updatedEquipment.channels = parseInt(e.target.value);
                                  newEquipments[indexEquipment] = updatedEquipment;
                                  setChannelPK(newChannelPk);
                                  setThresholdsValues(newThresholdValues);
                                  setThresholdsRanges(newThresholdRanges);
                                  setZones(newZones);
                                  setEquipment(newEquipments);
                                  setChannelToggle(newChannelToggle);
                                  setZoneToggle(newZoneToggle);
                                  setChannelDataToggle(newChannelDataToggle);
                                }
                              }}
                              type="number"
                              error={errors[equipment + indexEquipment + "_channels"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "measure.channels" })}
                              required
                            ></TextField>
                            {!isNil(errors[equipment + indexEquipment + "_channels"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors[equipment + indexEquipment + "_channels"] })}
                              </ErrorText>
                            )}
                            {e.equipmentType === "DAS" && (
                              <>
                                <TextField
                                  id={`channel_spatial_resolution_${indexEquipment}`}
                                  style={{ margin: "0 0.2rem 0.8rem" }}
                                  inputProps={{ min: 0 }}
                                  defaultValue={0}
                                  onChange={(e) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.spatialResolution = parseFloat(e.target.value);
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                  error={errors[`channel_spatial_resolution_${indexEquipment}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                                  required
                                  type="number"
                                ></TextField>
                                <TextField
                                  id={`channel_critical_area_${indexEquipment}`}
                                  style={{ margin: "0 0.2rem 0.8rem" }}
                                  inputProps={{ min: 0 }}
                                  defaultValue={0}
                                  onChange={(e) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.criticalArea.distance = parseFloat(e.target.value);
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                  error={errors[`channel_critical_area_${indexEquipment}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "critical.area" })}
                                  required
                                  type="number"
                                ></TextField>
                                <TextField
                                  id={`channel_protection_area_${indexEquipment}`}
                                  style={{ margin: "0 0.2rem 0.8rem" }}
                                  inputProps={{ min: 0 }}
                                  defaultValue={0}
                                  onChange={(e) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.protectionArea.distance = parseFloat(e.target.value);
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                  error={errors[`channel_protection_area_${indexEquipment}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "protection.area" })}
                                  required
                                  type="number"
                                ></TextField>
                                <Button
                                  variant="contained"
                                  id="area_button"
                                  style={{
                                    backgroundColor: palette.primary,
                                    color: "white",
                                    margin: "0 0.2rem 0.8rem",
                                    height: "10.5%",
                                  }}
                                  onClick={async () => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    const criticalArea = updatedEquipment.criticalArea.distance;
                                    const protectionArea = updatedEquipment.protectionArea.distance;

                                    const polys = await offsetPolygonPerSegment(
                                      polylineDisplay[0].points,
                                      criticalArea,
                                      protectionArea,
                                      updatedEquipment,
                                      intl,
                                    );
                                    setCriticalPolygon(polys.criticalCoords);
                                    setProtectionPolygon(polys.protectCoords);
                                    updatedEquipment.criticalArea.polygon = polys.criticalCoords;
                                    updatedEquipment.protectionArea.polygon = polys.protectCoords;
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                >
                                  {intl.formatMessage({ id: "calculate.area" })}
                                </Button>
                              </>
                            )}
                            <br></br>
                            <BootstrapButton
                              variant="contained"
                              id="name-to-channels"
                              style={{ marginTop: "1%" }}
                              onClick={() => {
                                let newChannel = clone(channelNameAsignToggle);
                                if (newChannel[indexEquipment]) {
                                  newChannel[indexEquipment] = false;
                                } else {
                                  newChannel[indexEquipment] = true;
                                }
                                setChannelNameAsignToggle(newChannel);
                              }}
                            >
                              {intl.formatMessage({ id: "channel.names" })}
                              {!channelNameAsignToggle[indexEquipment] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                            </BootstrapButton>
                            <Collapse in={channelNameAsignToggle[indexEquipment]}>
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  border: "none",
                                  marginTop: "1%",
                                  marginBottom: "1%",
                                }}
                              >
                                <tbody>
                                  {e.channels
                                    .reduce((rows, channel, indChan) => {
                                      if (indChan % 4 === 0) {
                                        rows.push([]);
                                      }

                                      rows[rows.length - 1].push(
                                        <ChannelInfo
                                          key={indChan}
                                          e={e}
                                          subs={subs}
                                          channel={channel}
                                          indChan={indChan}
                                          indexEquipment={indexEquipment}
                                          channelPK={channelPK}
                                          equipment={equipment}
                                          setEquipment={setEquipment}
                                          susbtructureDataToggle={susbtructureDataToggle}
                                          setSusbtructureDataToggle={setSusbtructureDataToggle}
                                          susbtructureAsignToggle={susbtructureAsignToggle}
                                          setSusbtructureAsignToggle={setSusbtructureAsignToggle}
                                          useStyles={useStyles}
                                          polylineDisplay={polylineDisplay}
                                          BootstrapButton={BootstrapButton}
                                          channelDataToggle={channelDataToggle}
                                          equipmentInterMeasurement={equipmentInterMeasurement}
                                          errors={errors}
                                          setErrors={setErrors}
                                          setEquipmentInterMeasurement={setEquipmentInterMeasurement}
                                          setChannelDataToggle={setChannelDataToggle}
                                          centroid={centroid}
                                          customCentroidIcon={customCentroidIcon}
                                          customIcon={customIcon}
                                          customShadowIcon={customShadowIcon}
                                          inclinometers={inclinometers}
                                          open={open}
                                          intl={intl}
                                        />,
                                      );

                                      return rows;
                                    }, [])
                                    .map((rowChannels, rowIndex) => (
                                      <tr
                                        key={`row-${rowIndex}`}
                                        style={{ borderCollapse: "collapse", border: "none" }}
                                      >
                                        {rowChannels.map((channelComponent) => (
                                          <td
                                            key={channelComponent.key}
                                            style={{ borderCollapse: "collapse", border: "none" }}
                                          >
                                            {channelComponent}
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </Collapse>
                            {!isEmpty(polylineDisplay) && (
                              <BootstrapButton
                                variant="contained"
                                id="polyline-to-channels"
                                onClick={() => {
                                  let newChannel = clone(channelAsignToggle);
                                  if (newChannel[indexEquipment]) {
                                    newChannel[indexEquipment] = false;
                                  } else {
                                    newChannel[indexEquipment] = true;
                                  }
                                  setChannelAsignToggle(newChannel);
                                }}
                              >
                                {intl.formatMessage({ id: "channels.to.polylines" })}
                                {!channelAsignToggle[indexEquipment] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                              </BootstrapButton>
                            )}

                            <Collapse in={channelAsignToggle[indexEquipment]}>
                              {e.channels.map((channel, indChan) => {
                                return (
                                  <div style={{ margin: "2%", display: "inline-block" }}>
                                    {indChan + 1}.
                                    <Select
                                      id={e.equipmentID + "channel" + indChan}
                                      onChange={(e) => {
                                        const newEquipments = [...equipment];
                                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                                        updatedEquipment.channels[indChan] = !isNil(e.target.value)
                                          ? parseInt(e.target.value)
                                          : e.target.value;
                                        newEquipments[indexEquipment] = updatedEquipment;
                                        let cloneRange = clone(thresholdsRanges);
                                        let newChannelPk = clone(channelPK);
                                        if (!isNil(e.target.value)) {
                                          for (
                                            let indexEquipment = 0;
                                            indexEquipment < Object.keys(thresholdsRanges).length;
                                            indexEquipment++
                                          ) {
                                            for (
                                              let indexMeasure = 0;
                                              indexMeasure < thresholdsRanges[`equipment${indexEquipment + 1}`].length;
                                              indexMeasure++
                                            ) {
                                              for (
                                                let indexChannel = 0;
                                                indexChannel <
                                                thresholdsRanges[`equipment${indexEquipment + 1}`][indexMeasure].length;
                                                indexChannel++
                                              ) {
                                                if (indexChannel === indChan) {
                                                  for (
                                                    let indexZone = 0;
                                                    indexZone <
                                                    thresholdsRanges[`equipment${indexEquipment + 1}`][indexMeasure][
                                                      indexChannel
                                                    ].length;
                                                    indexZone++
                                                  ) {
                                                    cloneRange[`equipment${indexEquipment + 1}`][indexMeasure][
                                                      indexChannel
                                                    ][indexZone][1] =
                                                      Math.round(
                                                        polylineDisplay[parseInt(e.target.value)].points[
                                                          polylineDisplay[parseInt(e.target.value)].points.length - 1
                                                        ].pk * 100,
                                                      ) / 100;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                          newChannelPk[indexEquipment][indChan] =
                                            Math.round(
                                              polylineDisplay[parseInt(e.target.value)].points[
                                                polylineDisplay[parseInt(e.target.value)].points.length - 1
                                              ].pk * 100,
                                            ) / 100;
                                          updatedEquipment.channelsLength[indChan] = parseFloat(
                                            Math.round(
                                              polylineDisplay[parseInt(e.target.value)].points[
                                                polylineDisplay[parseInt(e.target.value)].points.length - 1
                                              ].pk * 100,
                                            ) / 100,
                                          );
                                        }

                                        setChannelPK(newChannelPk);
                                        setThresholdsRanges(cloneRange);
                                        setEquipment(newEquipments);
                                      }}
                                      defaultValue={channel}
                                    >
                                      {polylineDisplay.map((p, indPoly) => {
                                        return (
                                          <MenuItem
                                            key={e.equipmentID + "channel" + indChan + "_" + indPoly}
                                            value={indPoly}
                                          >
                                            <div
                                              className={useStyles.colorSample}
                                              style={{
                                                backgroundColor: polylineColors[indPoly],
                                                width: "20px",
                                                height: "20px",
                                                display: "inline-block",
                                                marginRight: "8px",
                                                border: "1px solid #ccc",
                                              }}
                                            ></div>
                                          </MenuItem>
                                        );
                                      })}
                                      <MenuItem key={e.equipmentID + "channelnull"} value={null}>
                                        {intl.formatMessage({ id: "none" })}
                                      </MenuItem>
                                    </Select>
                                  </div>
                                );
                              })}
                            </Collapse>
                            {!isNil(errors[equipment + indexEquipment + "_duration"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors[equipment + indexEquipment + "_duration"] })}
                              </ErrorText>
                            )}
                            <TextField
                              id={equipment + indexEquipment + "_frequency"}
                              style={{ margin: "0 0.2rem 0.8rem", width: "50%" }}
                              defaultValue={e.measureFrequency}
                              value={e.measureFrequency}
                              inputProps={{ max: 86400, min: 0 }}
                              onChange={(e) => {
                                const newErrors = { ...errors };
                                if (isEmpty(e.target.value) || isNaN(e.target.value)) {
                                  newErrors[e.target.id] = "not.empty";
                                } else if (parseFloat(e.target.value) < equipmentInterMeasurement[indexEquipment]) {
                                  newErrors[e.target.id] = "not.higher.than.amount.measurement.time.channels";
                                } else if (parseFloat(e.target.value) > 86400) {
                                  newErrors[e.target.id] = "not.higher.than.day";
                                } else {
                                  delete newErrors[e.target.id];
                                }
                                setErrors(newErrors);

                                const newEquipments = [...equipment];
                                const updatedEquipment = { ...newEquipments[indexEquipment] };
                                updatedEquipment.measureFrequency = parseFloat(e.target.value);
                                newEquipments[indexEquipment] = updatedEquipment;

                                setEquipment(newEquipments);
                              }}
                              type="number"
                              error={errors[equipment + indexEquipment + "_frequency"] ? true : false}
                              variant="outlined"
                              label={intl.formatMessage({ id: "measure.frequency" })}
                              required
                            ></TextField>
                            {!isNil(errors[equipment + indexEquipment + "_frequency"]) && (
                              <ErrorText>
                                {intl.formatMessage({ id: errors[equipment + indexEquipment + "_frequency"] })}
                              </ErrorText>
                            )}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  id={"checkbox" + indexEquipment}
                                  sx={{
                                    color: palette.primary,
                                    "&.Mui-checked": {
                                      color: palette.primary,
                                    },
                                  }}
                                  defaultChecked={e.measurementState}
                                  onChange={(e) => {
                                    const newErrors = { ...errors };
                                    if (isEmpty(e.target.value)) {
                                      newErrors[e.target.id] = "not.empty";
                                    } else {
                                      delete newErrors[e.target.id];
                                    }
                                    setErrors(newErrors);

                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.measurementState = e.target.checked;
                                    newEquipments[indexEquipment] = updatedEquipment;

                                    setEquipment(newEquipments);
                                  }}
                                />
                              }
                              label={intl.formatMessage({ id: "measurement.state" })}
                            />
                          </Collapse>
                        </div>
                        <h1
                          onClick={() => {
                            let newMeasureToggle = clone(measureToggle);
                            if (newMeasureToggle[indexEquipment]) {
                              newMeasureToggle[indexEquipment] = false;
                            } else {
                              newMeasureToggle[indexEquipment] = true;
                            }
                            setMeasureToggle(newMeasureToggle);
                          }}
                          style={{ marginBottom: "3%" }}
                        >
                          {intl.formatMessage({ id: "measure.information" })}
                          {!measureToggle[indexEquipment] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                        </h1>
                        {measures[`equipment${indexEquipment + 1}`].map((measure, indexMeasure) => {
                          return (
                            <MeasurementInfo
                              e={e}
                              equipment={equipment}
                              indexEquipment={indexEquipment}
                              indexMeasure={indexMeasure}
                              measure={measure}
                              measureToggle={measureToggle}
                              measures={measures}
                              channelToggle={channelToggle}
                              errors={errors}
                              setErrors={setErrors}
                              intl={intl}
                              setThresholdsValues={setThresholdsValues}
                              setZoneToggle={setZoneToggle}
                              setZones={setZones}
                              thresholdType={thresholdType}
                              thresholdsRanges={thresholdsRanges}
                              thresholdsValues={thresholdsValues}
                              zoneToggle={zoneToggle}
                              zones={zones}
                              measuresAlerts={measuresAlerts}
                              measuresComputed={measuresComputed}
                              polylineDisplay={polylineDisplay}
                              setChannelToggle={setChannelToggle}
                              setMeasures={setMeasures}
                              setMeasuresAlerts={setMeasuresAlerts}
                              setThresholdsRanges={setThresholdsRanges}
                            />
                          );
                        })}

                        {!measuresComputed[`equipment${indexEquipment + 1}`].every((elemento) =>
                          measures[`equipment${indexEquipment + 1}`].includes(elemento),
                        ) &&
                        !isNil(objectMeasures.find((obj) => obj.name === e.equipmentType).measures) &&
                        !isNil(objectMeasures.find((obj) => obj.name === e.equipmentType).computing) &&
                        measures[`equipment${indexEquipment + 1}`].length <
                          objectMeasures.find((obj) => obj.name === e.equipmentType).measures.length +
                            objectMeasures.find((obj) => obj.name === e.equipmentType).computing.length ? (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <IconButton
                              style={{ backgroundColor: palette.dividerLight }}
                              key="add_magnitude"
                              onClick={() => {
                                //setTuples([...tuples, { type: null, value: null }]);
                                const localMeasures = clone(measures);
                                const localMeasuresAlerts = clone(measuresAlerts);
                                const localThresholdsValues = clone(thresholdsValues);
                                localMeasures[`equipment${indexEquipment + 1}`].push("");
                                localMeasuresAlerts[`equipment${indexEquipment + 1}`].push(0);
                                localThresholdsValues[`equipment${indexEquipment + 1}`].push([
                                  [[{ type: null, value: 0.5 }]],
                                ]);
                                setMeasures(localMeasures);
                                setMeasuresAlerts(localMeasuresAlerts);
                                setThresholdsValues(localThresholdsValues);
                              }}
                            >
                              <AddIcon sx={{ color: palette.primary }} />
                            </IconButton>
                            <div
                              style={{
                                width: "100%",
                                height: "1px",
                                backgroundColor: palette.primary,
                                margin: "8px 0",
                              }}
                            ></div>
                          </div>
                        ) : null}
                      </Collapse>
                    </div>
                  );
                })}
            </section>
          </Grid>
          <Grid item style={{ flex: "2" }}>
            <MapContainer
              id="map-equipment-id"
              center={[43, 0]}
              zoom={5}
              style={{ height: "calc(100vh - 320px)", width: "60vw" }}
              anima
            >
              <TileLayer
                attribution={IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
                url={MAP_TYPES.find((type) => type.value === mapType).tileLayer}
                maxZoom={20}
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
              />
              {centroid.length > 0 && <Marker key={"Centroid"} position={centroid} icon={customCentroidIcon}></Marker>}
              <MyComponentSetView polyline={polylineDisplay} />
              {isNil(polylineDisplay) &&
                polylineDisplay.length > 0 &&
                // eslint-disable-next-line array-callback-return
                polylineDisplay.map((polyline, index) => {
                  // eslint-disable-next-line array-callback-return
                  return polyline.points.map((point, indice) => {
                    if (indice === 0) {
                      return null;
                    }

                    if (polyline.p_indexes.includes(indice)) {
                      const previousIndex = polyline.p_indexes[polyline.p_indexes.indexOf(indice) - 1];
                      const center = [
                        [
                          polylineDisplay[index].points[previousIndex].lat,
                          polylineDisplay[index].points[previousIndex].lng,
                        ],
                        [point.lat, point.lng],
                      ];
                      let auxColor = "black";
                      for (let indexEquipment = 0; indexEquipment < equipment.length; indexEquipment++) {
                        if (equipment[indexEquipment].channels.includes(index)) {
                          auxColor = "red";
                        }
                      }
                      const color = polylineDisplay.length > 10 ? auxColor : polylineColors[index];
                      return (
                        <Polyline key={indice + "_" + index} color={color} positions={center} weight={5}></Polyline>
                      );
                    }
                  });
                })}
              <AddEquipment />
              {equipment.length > 0 &&
                equipment.map((equip, index) => (
                  <Marker
                    key={"equipment" + index}
                    position={[equip.latitude, equip.longitude]}
                    icon={open[index] ? customShadowIcon : customIcon}
                  ></Marker>
                ))}
              {inclinometers.length > 0 &&
                inclinometers.map((im, index) => (
                  <Marker key={"inclinometer" + index + im} position={im} icon={customInclinometerIcon}></Marker>
                ))}
            </MapContainer>
          </Grid>
        </Grid>
      </div>
    </ThemeProvider>
  );
};
export default EquipmentInfo;
